<div class="layout" [class.edit-layout]="editMode">
    <div class="left-menu">
        @if (editMode && sortLoading) {
            <div class="sorting-loading">
                <div class="fancy-loader"></div>
                <div class="sort-message">
                    <div class="title">{{ sortMessage }}</div>
                    @if (config.sortMessageSubtitle) {
                        <div class="sub-title">
                            {{ config.sortMessageSubtitle }}
                        </div>
                    }
                </div>
            </div>
        }
        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ name }}</div>
            <div class="detail-page-card-actions">
                <button
                    class="btn btn-raised"
                    data-uiid="tree-view-order-button"
                    (click)="toggleEditMode()"
                >
                    <i class="fas fa-sort me-2"></i>{{
                        (editMode
                            ? "treeView.completeOrderButton"
                            : "treeView.changeOrderButton"
                        ) | t
                    }}
                </button>
                <div class="spacer"></div>
                <button
                    type="button"
                    class="btn btn-raised export-button"
                    (click)="exportClick()"
                    [disabled]="isGeneratingExport"
                    title="{{ 'treeView.exportTitle' | t }}"
                >
                    @if (isGeneratingExport) {
                        <i class="fas fa-circle-notch fa-spin"></i>
                    } @else {
                        <i class="fas fa-file-excel" aria-hidden="true"></i>
                    }
                </button>
                @if (!editMode) {
                    <button class="btn btn-raised green" (click)="addNew()">
                        <i class="fas fa-plus me-2"></i>{{
                            "treeView.addRootButton" | t
                        }}
                    </button>
                    <button
                        class="btn btn-raised green"
                        (click)="addNew(selected)"
                        [disabled]="!selected"
                    >
                        <i class="fas fa-plus me-2"></i>{{
                            "treeView.addChildButton" | t
                        }}
                    </button>
                }
            </div>
            @if (!editMode) {
                <div class="detail-page-card-actions search-actions">
                    <input
                        type="text"
                        placeholder="{{ 'treeView.searchPlaceholder' | t }}"
                        class="form-control form-control-sm"
                        [(ngModel)]="searchFilter"
                        inputTooltip
                    />

                    <button
                        class="btn btn-outline-secondary btn-sm search-button"
                        (click)="search()"
                    >
                        <i class="fas fa-search"></i>
                    </button>
                    <button
                        class="btn btn-outline-secondary btn-sm search-reset-button"
                        (click)="resetSearchFilter()"
                    >
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            }
            @if (dataLoading) {
                <div class="detail-page-card-body">
                    <div class="fancy-loader submodule"></div>
                </div>
            } @else {
                <div class="detail-page-card-body cerrix-control-sm">
                    <div class="nodes">
                        @for (node of data; track node) {
                            <ng-container
                                *ngTemplateOutlet="
                                    nodeTemplate;
                                    context: { node: node, parent: null, depth: 0 }
                                "
                            >
                            </ng-container>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<ng-template #nodeTemplate let-node="node" let-parent="parent" let-depth="depth">
    <div
        class="node"
        [attr.data-uiid]="'tree-node-' + node.ID"
        [class.dropzone]="editMode && node.highlight"
        [class.dropabove]="editMode && dropAbove"
        [class.dropbelow]="editMode && dropBelow"
        [class.moving]="editMode && node.show === false"
        [class.just-moved]="editMode && node.newlocation"
        [class.selected]="!editMode && node.ID === selected"
        [ngStyle]="{ 'z-index': depth }"
        [class.filterhighlight]="!editMode && node.highlight"
        [class.filterhide]="!editMode && node.show === false"
        [draggable]="editMode && !sortLoading"
        (dragstart)="dragStart(node, parent, $event)"
        (dragend)="dragStop(node, $event)"
        (dragover)="dragOver($event)"
    >
        <div
            class="node-detail"
            [attr.data-uiid]="'tree-node-detail-' + node.ID"
            (drop)="dragDrop(node, parent, $event)"
            (dragenter)="dragEnter(node)"
            [title]="node.Name"
        >
            <div class="node-child-toggler">
                @if (node.Children.length > 0) {
                    <i
                        class="fas fa-angle-{{ node.isExpanded ? 'down' : 'right' }}"
                        [attr.data-uiid]="'tree-node-toggler-' + node.ID"
                        (click)="node.isExpanded = !node.isExpanded"
                    ></i>
                }
            </div>
            <div class="node-icon" (click)="itemClick(node)">
                <cerrix-icon-viewer [icon]="node.Icon" appendClass="fa-fw"></cerrix-icon-viewer>
            </div>
            <div class="node-name" (click)="itemClick(node)">{{ node.Name }}</div>
        </div>
        @if (node.isExpanded && node.Children.length > 0) {
            <div class="children">
                @for (child of node.Children; track child) {
                    <ng-container
                        *ngTemplateOutlet="
                            nodeTemplate;
                            context: { node: child, parent: node, depth: depth + 1 }
                        "
                    >
                    </ng-container>
                }
            </div>
        }
    </div>
</ng-template>
